import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import ProspectForm from 'components/modules/prospects/ProspectForm';

const ContactCompany = ({ data }) => {
 return (
  <>
   <Card className="mb-3">
    <FalconCardHeader title="Dejanos Contactarte" titleTag="h5" className="bg-light d-none d-lg-block mb-0 text-capitalize" />

    <Card.Body>
     <ProspectForm company={data.id} />
    </Card.Body>
   </Card>
  </>
 );
};

ContactCompany.propTypes = { data: PropTypes.object };

export default ContactCompany;
